import React from "react";
import { Grid } from "@mui/material";
import { Speaker as PASystemIcon } from "@mui/icons-material";
import type { VenueData } from "../../types/venues.types";

interface PASystemInfoCardProps {
  venueData: VenueData;
  InfoCard: React.ComponentType<{
    title: string;
    icon: React.ReactNode;
    sx?: object;
    children: React.ReactNode;
  }>;
  InfoRow: React.ComponentType<{
    label: string;
    value: string;
  }>;
}

export const PASystemInfoCard: React.FC<PASystemInfoCardProps> = ({
  venueData,
  InfoCard,
  InfoRow,
}) => {
  return (
    <InfoCard
      title="P.A System"
      icon={<PASystemIcon />}
      sx={{ height: "100%" }}
    >
      <Grid container spacing={2}>
        <InfoRow
          label="Has P.A System"
          value={venueData.has_pa_system ? "Yes" : "No"}
        />
        <InfoRow
          label="Distance from Livestream Desk"
          value={venueData.pa_system_distance_from_livestream || "N/A"}
        />
        <InfoRow
          label="P.A System Provider"
          value={venueData.pa_system_provider || "N/A"}
        />
        <InfoRow
          label="Other P.A System Provider"
          value={venueData.other_pa_system_service_provider || "N/A"}
        />
        <InfoRow
          label="Contact Phone"
          value={venueData.pa_system_contact_phone || "N/A"}
        />
        <InfoRow
          label="Contact Email"
          value={venueData.pa_system_contact_email || "N/A"}
        />
      </Grid>
    </InfoCard>
  );
};

export default PASystemInfoCard;
